// Forgiving string comparison for free-text translation answers.
// Strips diacritics (so "moze" ≈ "može"), lowercases, collapses whitespace,
// and removes most punctuation. Also tolerates a single typo when the
// answer is reasonably long, so a learner doesn't lose a heart for a slip.

export function normalize(s) {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip combining marks
    .replace(/đ/g, 'd')              // 'đ' doesn't decompose, handle explicitly
    .replace(/ø/g, 'o')
    .replace(/[.,!?;:"'`]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function levenshtein(a, b) {
  if (a === b) return 0;
  const m = a.length;
  const n = b.length;
  if (!m) return n;
  if (!n) return m;
  const prev = new Array(n + 1);
  const curr = new Array(n + 1);
  for (let j = 0; j <= n; j++) prev[j] = j;
  for (let i = 1; i <= m; i++) {
    curr[0] = i;
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
    }
    for (let j = 0; j <= n; j++) prev[j] = curr[j];
  }
  return prev[n];
}

export function answersMatch(given, expected, { strict = false } = {}) {
  const g = normalize(given);
  if (Array.isArray(expected)) {
    return expected.some((e) => answersMatch(given, e, { strict }));
  }
  const e = normalize(expected);
  if (!g || !e) return false;
  if (g === e) return true;
  if (strict) return false;
  // Allow a single-character typo for answers of >= 5 chars.
  if (e.length >= 5 && Math.abs(g.length - e.length) <= 1) {
    return levenshtein(g, e) <= 1;
  }
  return false;
}

// Accept any of the comma-or-slash separated alternatives in the answer text.
export function expandAlternatives(s) {
  return s
    .split(/[/,]/)
    .map((part) => part.trim())
    .filter(Boolean);
}
